module.exports = __webpack_public_path__ + "dfd62e74ca2fc6b3a048134ba56dc00a.svg";